import type { User } from 'firebase/auth';

/**
 * Mirrors the backend constant in `packages/backend/src/utils/firebaseClaims.ts`
 * (`APP_ACCESS_CLAIM`) — keep in sync. A typo here fails CLOSED (claim never
 * matches → user routed to the verify-email gate), never open.
 */
export const APP_ACCESS_CLAIM = 'app_access_ok';

/**
 * App-access equivalent of `user.emailVerified` for the verify-email gate.
 *
 * Microsoft SSO users carry `emailVerified: false` on the Firebase record —
 * the backend grants an `app_access_ok` CUSTOM CLAIM instead of promoting
 * the record bit (the promotion was the nOAuth laundering vector; see
 * auth-sso.controller.ts). The claim proves account control, which is all
 * the App.tsx verify-email gate requires. Reads the cached token result —
 * no network call after the post-signin force-refresh.
 */
export async function emailVerifiedForGate(user: User): Promise<boolean> {
  if (user.emailVerified) return true;
  try {
    const tokenResult = await user.getIdTokenResult();
    return tokenResult.claims[APP_ACCESS_CLAIM] === true;
  } catch {
    // Fail closed — the gate treats them as unverified; a token refresh
    // on the next auth-state tick retries.
    return false;
  }
}
